(function() {
  'use strict';
  
  let lastMediaId = null;
  
  function checkForSlideChange() {
    const activeSlide = document.querySelector('.swiper-slide-active');
    
    if (activeSlide) {
      const mediaId = activeSlide.getAttribute('data-media-id') || 
                      activeSlide.dataset.mediaId;
      
      // Solo actualizar si el media ID cambió
      if (mediaId && mediaId !== lastMediaId) {
        lastMediaId = mediaId;
        updatePrice(mediaId);
      }
    }
    
    // Verificar cada 200ms
    setTimeout(checkForSlideChange, 200);
  }
  
  function updatePrice(mediaId) {
    // Buscar variantes
    const scripts = document.querySelectorAll('script[id*="productVariants"]');
    let variants = [];
    
    scripts.forEach(function(script) {
      try {
        const data = JSON.parse(script.textContent);
        if (Array.isArray(data)) {
          variants = data;
        }
      } catch (e) {}
    });
    
    // Encontrar variante
    const variant = variants.find(function(v) {
      return v.featured_media && String(v.featured_media.id) === String(mediaId);
    });
    
    if (variant && variant.price) {
      const price = '$' + (variant.price / 100).toFixed(2);
      const priceElements = document.querySelectorAll('.m-price-item--regular');
      
      priceElements.forEach(function(el) {
        if (el.offsetParent !== null) {
          el.textContent = price;
        }
      });
    }
  }
  
  // Iniciar verificación continua
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkForSlideChange);
  } else {
    checkForSlideChange();
  }
})();




